const STORAGE_KEY = "recentAccounts";
const MAX_ACCOUNTS = 3;

export interface RecentAccount {
  email: string;
  name: string;
}

export function getRecentAccounts(): RecentAccount[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const accounts = JSON.parse(raw);
    if (!Array.isArray(accounts)) return [];

    return accounts
      .filter((a: unknown) => a && typeof (a as any).email === "string" && (a as any).email.length > 0 && typeof (a as any).name === "string" && (a as any).name.length > 0)
      .map((a: any) => ({ email: a.email.slice(0, 254), name: a.name.slice(0, 100) }))
      .slice(0, MAX_ACCOUNTS);
  } catch {
    return [];
  }
}

export function saveRecentAccount(account: RecentAccount): void {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    const all: RecentAccount[] = Array.isArray(parsed) ? parsed : [];
    const filtered = all.filter((a: any) => typeof a?.email === "string" && a.email !== account.email);
    filtered.unshift(account);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_ACCOUNTS)));
  } catch {
    // localStorage unavailable — silently fail
  }
}

export function removeRecentAccount(email: string): void {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    const all: any[] = Array.isArray(parsed) ? parsed : [];
    const filtered = all.filter((a: any) => typeof a?.email === "string" && a.email !== email);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_ACCOUNTS)));
  } catch {
    // localStorage unavailable — silently fail
  }
}
